import { Text } from '@wix/design-system';
import React from 'react';
export const DisclaimerText = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true,
    inline: true
  }, children);
};
//# sourceMappingURL=DisclaimerText.js.map